import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Table, TableHead, TableBody, TableRow, TableCell, Button, IconButton, Tooltip, Chip,
  TablePagination
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import Menu from "../../Menu";
import Header from "../../Header";
import { http } from "../../../services/http";
import { FormsApi, API_RESOURCE, fmtDateTime } from "../formsUtils";
import { downloadXlsx } from "../../operator/Utils";
import ResponseDetail from "./ResponseDetail";

export default function ResponsesTable() {
  const history = useHistory();
  const state = history.location.state || {};
  const formId = state.formId;
  const title = state.title || "Formulário";

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(25);
  const [detail, setDetail] = useState({ open: false, responseId: null });
  // id do cálculo -> nome, para o cabeçalho não mostrar calc_age_from_birth_date
  const [calcNames, setCalcNames] = useState({});

  function load() {
    if (!formId) { history.push("/forms"); return; }
    // a API pagina a partir de 1
    FormsApi.listResponses(formId, `?page=${page + 1}&limit=${limit}`).then(
      (resp) => {
        setRows(resp?.data?.data || []);
        setTotal(resp?.data?.total || 0);
        setCalcNames(resp?.data?.calculation_names || {});
      },
      (error) => console.log(error)
    );
  }

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [formId, page, limit]);

  function handleExport() {
    http.get(`${API_RESOURCE}/${formId}/responses/export/xlsx`, { responseType: "blob" }).then(
      (response) => downloadXlsx(response.data),
      (error) => console.log(error)
    );
  }

  // colunas de escore: união das chaves computed
  const scoreKeys = Array.from(new Set(
    rows.flatMap((r) => (r.computed ? Object.keys(r.computed) : []))
  ));

  return (
    <div id="wrapper">
      <Menu />
      <div id="page-wrapper" className="gray-bg">
        <Header />
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-8">
            <Button startIcon={<ArrowBackIcon />} onClick={() => history.push("/forms")}>Voltar</Button>
            <h2 style={{ marginTop: 8 }}>Respostas — {title}</h2>
          </div>
          <div className="col-lg-4" style={{ textAlign: "right", paddingTop: 20 }}>
            <Button variant="outlined" startIcon={<DownloadIcon />} onClick={handleExport}>
              Exportar xlsx
            </Button>
          </div>
        </div>

        <div className="wrapper wrapper-content animated fadeInRight">
          <div className="row"><div className="col-lg-12"><div className="ibox"><div className="ibox-content">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Paciente</TableCell>
                  {scoreKeys.map((k) => <TableCell key={k} align="center">{calcNames[k] || k}</TableCell>)}
                  <TableCell>Enviado em</TableCell>
                  <TableCell align="right">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id} hover>
                    <TableCell>{row.id}</TableCell>
                    <TableCell>
                      <div>{row.contact_name || "-"}</div>
                      <small style={{ color: "#888" }}>{row.contact_phone || row.external_ref || ""}</small>
                    </TableCell>
                    {scoreKeys.map((k) => (
                      <TableCell key={k} align="center">
                        {row.computed && row.computed[k] !== undefined
                          ? <Chip size="small" label={String(row.computed[k])} /> : "-"}
                      </TableCell>
                    ))}
                    <TableCell>{fmtDateTime(row.submitted_at)}</TableCell>
                    <TableCell align="right">
                      <Tooltip title="Ver insumo">
                        <IconButton size="small" onClick={() => setDetail({ open: true, responseId: row.id })}>
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
                {rows.length === 0 && (
                  <TableRow><TableCell colSpan={4 + scoreKeys.length} align="center" style={{ color: "#999", padding: 40 }}>
                    Nenhuma resposta recebida ainda.
                  </TableCell></TableRow>
                )}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={total}
              page={page}
              onPageChange={(_, novaPagina) => setPage(novaPagina)}
              rowsPerPage={limit}
              onRowsPerPageChange={(e) => { setLimit(parseInt(e.target.value, 10)); setPage(0); }}
              rowsPerPageOptions={[25, 50, 100]}
              labelRowsPerPage="Por página"
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            />
          </div></div></div></div>
        </div>
      </div>

      <ResponseDetail
        open={detail.open}
        responseId={detail.responseId}
        formId={formId}
        onClose={() => setDetail({ open: false, responseId: null })}
      />
    </div>
  );
}
